import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, Button, IconButton } from '@material-ui/core';
import LoadingIcon from '../Common/LoadingIcon';
// import { withdrawValidation, clearSuccess,openOtpForm } from '../../store/actions/user.actions';
import { withdraw, clearSuccess } from '../../store/actions/user.actions';
import { Translate } from '../../localization';
import { currencyType } from '../../config';
import { toastr } from 'react-redux-toastr';
// import PhoneRegisterForm from '../../Desktop/MyAccount/PhoneRegisterForm';
// import OpenOtp from '../../Desktop/MyAccount/OpenOtp';

class WithdrawModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputAmount: 0,
            inputAddress: null,
            inputCurrency: null,
            amountError: null,
            addressError: null,
            currencyError: null,
            loading: false,
            // phoneNumberRegistered: false,
            // isOpen: false,
        };
    }

    // componentDidMount () {
    //     if(this.props.userData.country_code && this.props.userData.phone_number){
    //        this.setState({phoneNumberRegistered: true})
    //        this.setState({isOpen:false})
    //     }  
    // }
    validate(prevState) {
        if (prevState) {
            if (prevState.inputAmount !== this.state.inputAmount) {
                if (!this.state.inputAmount) {
                    this.setState({ amountError: Translate.required });
                } else {
                    this.setState({ amountError: false });
                }
            }

            if (prevState.inputAddress !== this.state.inputAddress) {
                if (!this.state.inputAddress) {
                    this.setState({ addressError: Translate.required });
                } else {
                    this.setState({ addressError: false });
                }
            }

            if (prevState.inputCurrency !== this.state.inputCurrency) {
                if (!this.state.inputCurrency) {
                    this.setState({ currencyError: Translate.required });
                } else {
                    this.setState({ currencyError: false });
                }
            }
        } else {
            if (this.state.inputAmount < 23) {
                this.setState({ amountError: Translate.greaterThanZero });
            }
            if (!this.state.inputAddress) {
                this.setState({ addressError: Translate.required });
            }
            if (!this.state.inputCurrency) {
                this.setState({ currencyError: Translate.required });
            }
        } 
    }
    componentDidUpdate(prevProps, prevState){
        const { withdrawError, withdrawSuccess } = this.props;
        if(prevProps.withdrawError !== withdrawError){
            this.setState({ ...this.state, loading: false });
            if (withdrawError) toastr.error('', withdrawError);
        }

        if(prevProps.withdrawSuccess !== withdrawSuccess){
            this.setState({ ...this.state, loading: false });
            if (withdrawSuccess) toastr.success('', withdrawSuccess);
            setTimeout(() => {
                this.props.hideWithdrawForm();
            }, 2500);
        }

        // if( prevProps.userData!== this.props.userData){
        //    this.setState({phoneNumberRegistered: true})
        //    this.setState({isOpen:false})
        // }  

        //  if(prevProps.getOtpError !== this.props.getOtpError){
        //         this.setState({ ...this.state, loading: false });
        // }
        this.validate(prevState);
    }

    componentWillUnmount() {
        this.props.clearSuccess();
    }

    handleSubmit = (e) => {
        //  if(this.state.phoneNumberRegistered && !this.state.isOpen){
        const { inputAmount,inputAddress, inputCurrency, addressError, amountError, currencyError } = this.state;  
        if (!addressError
            && !amountError
            && !currencyError
            && inputAmount > 0
            && inputAddress && inputAddress.length > 0
            && inputCurrency && inputCurrency.length > 0
            ) {
            this.setState({ loading: true });
            this.props.withdraw({ 
                amount: inputAmount,
                address: inputAddress,
                currency: inputCurrency,
            });
        } else {
            this.validate();
        }
    // } else{
    //      this.setState({phoneNumberRegistered: false});
    //      this.setState({isOpen:true})
    //     }
    };

    handleChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.id]: e.target.value,
            loading: false
        });
    }

     hideForm = () => {
        this.setState({isOpen : false });
    }

    // hideFormOtp = () => {
    //      this.props.openOtpForm(false);
    // }

    render() {
        const currencyList = currencyType.map((option) => (
            <option key={option.value} value={option.value} selected={ this.state.inputCurrency === option.value }>
                {option.name}
            </option>
        ));
        return (
            <>
            <Dialog onClose={this.props.hideWithdrawForm} aria-labelledby="change-password-dialog-title" open={true} className="auth__modal" scroll="body">
                <DialogTitle id="change-password-dialog-title" disableTypography>
                    <h3 className="m-0 fs-17">{Translate.withdraw}</h3>
                    <IconButton aria-label="close" className="close-modal" onClick={this.props.hideWithdrawForm}>
                        <i className=" material-icons fs-22"> close </i>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            this.handleSubmit();
                        }}
                        >
                        <div className={'mt-1 placeholder-color'}>
                            <input
                                    type="number"
                                    className="auth__input"
                                    id='inputAmount'
                                    placeholder={Translate.enterAmount}
                                    onChange={this.handleChange}
                                />
                            {
                                    this.state.amountError && <p className="auth__error sm">{ this.state.amountError }</p>
                                }
                        </div>
                        <div className={'mt-1 placeholder-color'}>
                            <input
                                    type="text"
                                    className="auth__input"
                                    id='inputAddress'
                                    placeholder={Translate.coinAddress}
                                    autocomplete="off"
                                    onChange={this.handleChange}
                                />
                            {
                                    this.state.addressError && <p className="auth__error sm">{ this.state.addressError }</p>
                                }
                        </div>
                        <div className={'mt-1'}>
                            <select className='auth__input select_height deposit_select' id='inputCurrency' onChange={ this.handleChange }>
                                <option disabled selected className='disabled'>{ Translate.currency}</option>
                                { currencyList }
                            </select>
                            {
                                    this.state.currencyError && <p className="auth__error sm">{ this.state.currencyError }</p>
                                }
                        </div>
                        <div className="auth__btn-wrap">
                            <Button
                                    variant="contained"
                                    className="auth__btn d-flex justify-content-center align-items-center select_height"
                                    type="submit"
                                    disabled={ this.state.loading }
                                >
                                {this.state.loading ? <LoadingIcon /> : Translate.withdraw }
                            </Button>
                        </div>
                    </form>
                </DialogContent>
            </Dialog>
           {/* {this.state.isOpen && <PhoneRegisterForm hideForm = {this.hideForm}/>}z */}
           {/* {this.props.openotpForm && <OpenOtp hideFormOtp = {this.hideFormOtp}/>} */}
        </>
        );
    }
}

WithdrawModal.propTypes = {
    hideWithdrawForm: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        withdrawSuccess: state.user.withdrawSuccess,
        withdrawError: state.user.withdrawError,
        userData: state.user.data,
        openotpForm: state.user.openOtpForm,
        getOtpError: state.user.getOtpError,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        // withdrawValidation: (inputObj) => dispatch(withdrawValidation(inputObj)),
        clearSuccess: () => dispatch(clearSuccess()),
        // openOtpForm : (val) =>dispatch(openOtpForm(val))
        withdraw: (obj) => dispatch(withdraw(obj))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithdrawModal);
